/* events.js
 *
 * This module defines all "app events" that are tracked by marketing software.
 *
 * The naming convention is broken into three parts: area, action, item
 * areas:
 *  home - homepage / marketing site
 *  app - dashboard/upload flow
 *  lp - landing page (future use)
 *  checkout - checkout flow
 * actions:
 *   clicked, visited, uploaded
 * item:
 *   typically a dashed name
 *   sometimes add -success or -failure
 *
 * The combined event name formula is `area: action-item`
 */

export function uploadPageVisited() {
  _track('app', 'visited', 'upload-page');
}

export function uploadedFileSuccess() {
  _track('app', 'uploaded', 'file-success');
}

export function uploadedFileError(error) {
  _track('app', 'uploaded', 'file-error', {error});
}

export function designUploadVisited(context) {
  // context is new-design | re-upload | add-design
  _track('app', 'design', 'upload-visited', {context});
}

export function designUploadSuccess() {
  _track('app', 'design', 'file-success');
}

export function designUploadError(error) {
  _track('app', 'design', 'file-error', {error});
}

export function designSetTemplate() {
  _track('app', 'design', 'set-template');
}

export function fontsMissingWarning(fonts) {
  _track('app', 'fonts', 'missing-warning', {fonts});
}

export function downloadStarterPack() {
  // TODO
}

export function downloadLeadMagnet() {
  // TODO
}

export function userInviteSent(invitedEmail, userType) {
  _track('app', 'team', 'invite-sent', {invitedEmail, userType});
}

export function userInviteAccepted() {
  _track('app', 'team', 'invite-accepted');
}

export function userSignedUp() {
  _track('app', 'user', 'signup');
}

export function userJoinedTeam() {
  _track('app', 'team', 'user-signup');
}

export function adminLinkShare(method) {
  // method: 'reveal' | 'copy' | other things in future
  _track('app', 'team', 'join-link-share', {method});
}

export function lineAddedToCart() {
  _track('cart', 'line', 'added');
}

export function orderPlaced({paymentMethod, numItems, total}) {
  let value = Math.round(total * 100);  // Convert to cents
  _track('checkout', 'order', 'placed', {
    value,   // only value tracked by GA
    paymentMethod,
    numItems
  });
}

export function viewedPricing(location) {
  _track('app', 'pricing', 'viewed', {location});
}

export function launchTourClicked(tour) {
  _track('tour', 'launch', 'clicked', {tour});
}

// Utility methods
function _track(area, action, item, extra) {
  let evt = area + ': ' + action + '-' + item;
  gaEvent(area, action, item, extra);
  intercomEvent(evt, extra);
  dripEvent(evt, extra);
  amplitudeEvent(evt, extra);
  userpilotEvent(evt, extra);
}

function gaEvent(category, action, label, {value, ...extra}={}) {
  if (typeof value !== 'number') {
    // GA can't handle non-numbers here
    extra.value = value;
    value = null;
  }
  if (!window.ga) {
    console.log('gaEvent - ga not installed!', {category, action, label, value, extra});
  } else {
    // TODO check if this is the right tracker or send to all?
    window.ga(() => {
      let tracker = window.ga.getAll()[0];
      tracker.send("event", category, action, label, value, extra);
      console.log('events->ga', {category, action, label, value, extra});
    })
  }
}

function intercomEvent(eventName, meta) {
  if (!window.Intercom) console.log('intercomEvent - Intercom not installed');
  else Intercom('trackEvent', eventName, meta), console.log('intercomEvent', eventName, meta);
}

function dripEvent(evt, extra) {
  // NOTE: "value" is a special key, must be in cents
  if (window._dcq) {
    window._dcq.push(["track", evt, extra]);
  }
}

function amplitudeEvent(evt, extra) {
  if (window.amplitude) {
    amplitude.getInstance().logEvent(evt, extra);
  }
}

function userpilotEvent(evt, extra) {
  if (window.userpilot) {
    window.userpilot.track(evt, extra);
  }
}



// WEBPACK FOOTER //
// ./src/lib/track/events.js